var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$slots.default)?_c('div',[_vm._t("default",null,{"changed":_setup.changed})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }